/**
 * tracking/index.js — Entry point del modulo tracking.
 *
 * Registra gli hook di tracking sugli store Alpine.js ed espone
 * l'API globale window.ikTracking per uso dal consent store.
 *
 * Per disabilitare tutto il tracking: commentare le 2 righe in app.js
 * (import + initTracking). Vite tree-shaking rimuove il codice dal bundle.
 */

import { track, trackEcommerce, updateConsent, generateEventId, buildGA4Item } from './tracker.js';
import { applyTrackingHooks } from './hooks.js';

export function initTracking(Alpine) {
    // Bail out se tracking esplicitamente disabilitato
    if (window.IKOS?.tracking?.enabled === false) return;

    // Esponi globalmente per il consent store e per event_id passthrough
    window.ikTracking = {
        track,
        trackEcommerce,
        updateConsent,
        generateEventId,
        buildGA4Item,
    };

    // Applica gli hook (wrappa i metodi degli store)
    applyTrackingHooks(Alpine);
}
